import React, { useEffect, useState } from "react";
import api from "../../api";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { TextStyle } from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import Highlight from "@tiptap/extension-highlight";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import FontFamily from "@tiptap/extension-font-family";

import FontSize from "./FontSizeExtension";
import MathExtension from "./MathExtension";
import CustomImageExtension from "./CustomImageExtension";
import MenuBar from "./MenuBar";

const AdminEditBlog = () => {
  const [blogs, setBlogs] = useState([]);
  const [editingBlogId, setEditingBlogId] = useState(null);
  const [title, setTitle] = useState("");
  const token = localStorage.getItem("token");

  // ✅ SINGLE EDITOR INSTANCE
  const editor = useEditor({
    extensions: [
      StarterKit,
      TextStyle,
      FontFamily,
      FontSize,
      Color,
      Underline,
      Highlight.configure({ multicolor: true }),
      Subscript,
      Superscript,
      Link.configure({ openOnClick: false }),
      TextAlign.configure({ types: ["heading", "paragraph"] }),
      Placeholder.configure({ placeholder: "Edit blog content..." }),
      MathExtension,
      CustomImageExtension,
    ],
    content: "",
  });

  // FETCH BLOGS (no content rendering here)
  useEffect(() => {
    api
      .get("/api/blog/getall", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setBlogs(res.data));
  }, [token]);

  // START EDIT
  const handleEdit = (blog) => {
    setEditingBlogId(blog.id);
    setTitle(blog.title);

    if (editor && blog.textContent) {
      editor.commands.setContent(JSON.parse(blog.textContent)); // ✅ LOAD JSON
    }
  };

  // IMAGE UPLOAD (keeps resize + layout)
  const handleImageUpload = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);

      const res = await api.post("/api/blog/upload-image", formData);
      editor.chain().focus().setImage({ src: res.data.url }).run();
    };
  };

  // SAVE BLOG
  const handleSave = async (id) => {
    await api.put(
      `/api/blog/text/${id}`,
      {
        title,
        textContent: JSON.stringify(editor.getJSON()),
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    alert("✅ Blog updated");
    setEditingBlogId(null);
    editor.commands.clearContent();
  };

  return (
    <div className="container my-5">
      {blogs.map((blog) => (
        <div key={blog.id} className="card mb-4 shadow">
          <div className="card-body">
            {editingBlogId === blog.id ? (
              <>
                <input
                  className="form-control mb-3"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                <MenuBar editor={editor} onImageUpload={handleImageUpload} />

                <EditorContent
                  editor={editor}
                  className="border p-3 rounded tiptap-editor"
                />

                <div className="mt-3 text-end">
                  <button
                    className="btn btn-success me-2"
                    onClick={() => handleSave(blog.id)}
                  >
                    💾 Save
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setEditingBlogId(null)}
                  >
                    ❌ Cancel
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* 🔹 MAIN PAGE: TITLE ONLY */}
                <h5 className="mb-2">{blog.title}</h5>
                <button
                  className="btn btn-warning"
                  onClick={() => handleEdit(blog)}
                >
                  ✏️ Edit
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminEditBlog;
